import AssociationsNavBar from "AssociationsNavBar";
import AssociationsForm from "AssociationsForm";
import AssociationsFooter from "AssociationsFooter";
import AssociationsHeader from "AssociationsHeader";

function App() {
  return (
    <>
      <AssociationsNavBar />
      <AssociationsHeader />
      <AssociationsForm />
      <AssociationsFooter />
    </>
  );
}

export default App;
